module.exports = __webpack_public_path__ + "assets/img/用户名.6bb470ab.png";